<template>
  <div>
    <ListEdit
      v-model="localQuestions"
      label="Preguntas de la plantilla"
      @handleAdd="handleAdd"
      @handleRemove="handleRemove"
      :minItems="1"
    >
      <template #header>
        <div class="d-flex align-items-center g-1">
          <div class="row flex-grow-1 g-1 me-2">
            <div class="col-6 text-muted small">Pregunta</div>
            <div class="col-2 text-muted small">Título cargo</div>
            <div class="col-2 text-muted small">Título fecha</div>
            <div class="col-2 text-muted small">Tipo</div>
          </div>
        </div>
      </template>
      <template #default="{ index }">
        <div>
          <div class="d-flex align-items-center mb-2 g-1">
            <div class="row flex-grow-1 g-1 me-2">
              <div class="col-6">
                <input
                  class="form-control form-control-sm"
                  type="text"
                  v-model="localQuestions[index].name"
                  :placeholder="'Pregunta ' + (index + 1)"
                  required
                />
              </div>
              <div class="col-2">
                <input
                  class="form-control form-control-sm"
                  type="text"
                  v-model="localQuestions[index].fieldNameCargo"
                  :placeholder="'Título cargo ' + (index + 1)"
                />
              </div>
              <div class="col-2">
                <input
                  class="form-control form-control-sm"
                  type="text"
                  v-model="localQuestions[index].fieldNameDate"
                  :placeholder="'Título fecha ' + (index + 1)"
                />
              </div>
              <div class="col-2">
                <b-form-select
                  v-model="localQuestions[index].type"
                  :options="questionTypeOptions"
                  class="form-control form-control-sm"
                  required
                ></b-form-select>
              </div>
            </div>
          </div>
        </div>
      </template>
    </ListEdit>

    <div class="d-flex justify-content-end mt-3">
      <b-button
        variant="primary"
        @click="saveQuestions"
        :disabled="localQuestions.length === 0"
        >Guardar Preguntas</b-button
      >
      <AlertDismiss ref="alertDismiss" />
    </div>
  </div>
</template>

<script>
import ListEdit from "@/components/shared/List-edit.vue";
import AlertDismiss from "@/components/shared/Alert-dismiss.vue";

export default {
  name: "StatementQuestionModal",

  components: {
    ListEdit,
    AlertDismiss,
  },

  props: {
    initialQuestions: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  data() {
    return {
      localQuestions: [],
      questionTypeOptions: [
        { value: null, text: "-- Seleccione --", disabled: true },
        { value: "SocietyList", text: "Listado" },
        { value: "SocietyBool", text: "Sí / No" },
      ],
    };
  },

  watch: {
    initialQuestions: {
      immediate: true,
      handler(newVal) {
        this.localQuestions = JSON.parse(JSON.stringify(newVal)).map((q) => ({
          name: q.name,
          type: q.type || null,
          fieldNameCargo: q.fieldNameCargo || null,
          fieldNameDate: q.fieldNameDate || null,
          // No subquestion properties here as Family Statements do not have subquestions
        }));
        if (this.localQuestions.length === 0) {
          this.handleAdd();
        }
      },
    },
  },

  methods: {
    handleAdd() {
      this.localQuestions.push({
        name: null,
        type: null,
        fieldNameCargo: null,
        fieldNameDate: null,
        // No subquestion properties here as Family Statements do not have subquestions
      });
    },

    handleRemove(index) {
      this.localQuestions.splice(index, 1);
    },

    saveQuestions() {
      const questionsToEmit = this.localQuestions.map((q) => ({
        name: q.name,
        type: q.type,
        fieldNameCargo: q.fieldNameCargo,
        fieldNameDate: q.fieldNameDate,
        // No subquestions in the emitted payload as Family Statements do not have subquestions
      }));
      this.$emit(
        "update-questions",
        JSON.parse(JSON.stringify(questionsToEmit))
      );
    },
    // Removed all subquestion-related methods as Family Statements do not have subquestions
  },
};
</script>
